import React, { useEffect, useState } from "react";
import api from "../../api";

export default function SchedulePage() {
  const [outlets, setOutlets] = useState([]);
  const [playlists, setPlaylists] = useState([]);

  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [selectedPlaylists, setSelectedPlaylists] = useState([]);

  const [assignedList, setAssignedList] = useState([]);

  useEffect(() => {
    loadOutlets();
    loadPlaylists();
    loadAssigned();
  }, []);

  const loadOutlets = async () => {
    const res = await api.get("/api/outlets");
    setOutlets(res.data);
  };

  const loadPlaylists = async () => {
    const res = await api.get("/api/playlist/list");
    setPlaylists(res.data);
  };

  const loadAssigned = async () => {
    const res = await api.get("/api/schedule");
    setAssignedList(res.data);
  };

  const assignPlaylists = async () => {
    if (!selectedOutlet || selectedPlaylists.length === 0) {
      alert("Please select Outlet and at least one Playlist.");
      return;
    }

    await api.post("/api/schedule/assign", {
      outletId: selectedOutlet,
      playlistIds: selectedPlaylists,
    });

    loadAssigned();
    alert("Playlists assigned successfully!");
  };

  return (
    <div className="p-1 sm:p-4">

      {/* TITLE SECTION */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 text-center">
          Schedule Playlists
        </h1>
        <p className="text-gray-500 mt-1 text-center">
          Assign one or multiple playlists to any outlet.
        </p>
      </div>

      {/* ASSIGN BLOCK */}
      <div className="bg-white p-6 shadow-md rounded-xl mb-10 border border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800 mb-5">
          Assign Playlists to an Outlet
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* Outlet Dropdown */}
          <div>
            <label className="font-semibold text-gray-700">Select Outlet</label>
            <select
              className="mt-2 w-full border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-green-500"
              value={selectedOutlet}
              onChange={(e) => setSelectedOutlet(e.target.value)}
            >
              <option value="">Choose Outlet</option>
              {outlets.map((o) => (
                <option key={o._id} value={o._id}>
                  {o.name} — {o.city}
                </option>
              ))}
            </select>
          </div>

          {/* Playlist Multi Selector */}
          <div>
            <label className="font-semibold text-gray-700">Select Playlist(s)</label>
            <select
              multiple
              className="mt-2 w-full border-gray-300 rounded-md p-2 h-40 focus:ring-2 focus:ring-green-500"
              value={selectedPlaylists}
              onChange={(e) =>
                setSelectedPlaylists(
                  Array.from(e.target.selectedOptions, (opt) => opt.value)
                )
              }
            >
              {playlists.map((pl) => (
                <option key={pl._id} value={pl._id}>
                  {pl.name}
                </option>
              ))}
            </select>
            <p className="text-xs text-gray-500 mt-2">
              Hold CTRL (Windows) or CMD (Mac) to select multiple.
            </p>
          </div>
        </div>

        {/* Assign Button */}
        <button
          onClick={assignPlaylists}
          className="mt-6 bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-2 rounded-lg shadow"
        >
          Assign Playlists
        </button>
      </div>

      {/* ASSIGNED TABLE */}
      <div className="bg-white p-6 shadow-md rounded-xl border border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Assigned Outlets
        </h2>

        <div className="overflow-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100 border-b border-gray-300 text-gray-700">
                <th className="p-3 text-left font-semibold">Outlet</th>
                <th className="p-3 text-left font-semibold">City</th>
                <th className="p-3 text-left font-semibold">Assigned Playlists</th>
              </tr>
            </thead>

            <tbody>
              {assignedList.map((a) => (
                <tr
                  key={a._id}
                  className="border-b hover:bg-gray-50 transition"
                >
                  <td className="p-3 text-gray-800">{a.outletId?.name}</td>
                  <td className="p-3 text-gray-600">{a.outletId?.city}</td>
                  <td className="p-3">
                    {a.playlistIds?.length > 0 ? (
                      a.playlistIds.map((pl) => (
                        <span
                          key={pl._id}
                          className="inline-block px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm mr-2 mb-2"
                        >
                          {pl.name}
                        </span>
                      ))
                    ) : (
                      <span className="text-gray-400">No playlist assigned</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
